




















































import Vue, { PropOptions } from 'vue';
import AccountModalBase from '@/parts/account/AccountModalBase.vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import {getAddressData} from '@/api/util/zipcloud';

// 都道府県リスト
const PREF_LIST = NOC.PREFECTURE.getOptions();

export default Vue.extend({
  name: 'AddressChangeModal',
  components: {
    AccountModalBase,
    VariableInput,
  },
  props: {
    accountData: Object as PropOptions<models.IAccount>,
  },
  data() {
    return {
      formData: {} as models.IAccount,
      items: [
      {key: 'postalCode', name: '郵便番号', type: vi.INPUT_TYPE.TEXT, placeholder: '150-0001', required: true, checks: [vi.CHECK_TYPE.POSTAL_CODE], error: '', min: 7, max: 8, class: 'postcode'},
      {key: 'postalCodeButton', name: '自動入力', class: 'postcode-btn'},
      {key: 'prefCode', name: '都道府県', type: vi.INPUT_TYPE.SELECT, placeholder: '', required: true, error: '', options: PREF_LIST, class: 'addresses'},
      {key: 'address', name: '市区町村・番地', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: true, checks: [], error: '', max: 100, class: 'addresses'}, // 旧：住所
      {key: 'building', name: '建物名', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: false, checks: [], error: '', max: 60, class: 'addresses'},
      ] as vi.IVariableInput[],
      isGettingAddress: false,
    };
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(this.accountData));
  },
  methods: {
    onInputItem(key: string, value: any) {
      if (key === 'prefCode') {
        this.checkPrefCode(value);
      }
    },
    // 住所自動入力
    async onClickAutoAddress() {
      // 入力チェック
      const postalItem = this.items.find((v) => v.key === 'postalCode');
      if (!postalItem || vi.checkValue(this.formData.postalCode, postalItem)) {
        return;
      }
      // 住所情報を取得
      this.isGettingAddress = true;
      const zipResult = await getAddressData(this.formData.postalCode);
      this.isGettingAddress = false;
      if (zipResult.success && zipResult.results) {
        const result = zipResult.results[0];
        this.formData.prefCode = Number(result.prefcode);
        this.formData.address = result.address2 + result.address3;
        this.formData.building = '';
        // 入力エラーをリセット
        const items = this.items.filter((v) => v.key === 'address' || v.key === 'building');
        for (const item of items) {
          item.error = '';
        }
      } else {
        console.log(zipResult.message);
      }
    },
    onClickChange() {
      // vallidation check
      if (vi.checkValues(this.formData, this.items) > 0) {
        return;
      }
      // 都道府県の必須チェック
      if (!this.checkPrefCode(this.formData.prefCode)) {
        return;
      }
      this.$emit('change', this.formData);
    },
    checkPrefCode(prefCode: number): boolean {
      // 都道府県の必須チェック
      let errMsg = '';
      if (prefCode === NOC.SELECT.NOSELECT.value) {
        errMsg = '必須項目です。';
      }
      this.items[2].error = errMsg;
      return errMsg.length < 1;
    },
  },
});
